<template>
  <v-row class="menu px-0 pt-1">
    <v-col cols="12" sm="11 " class="py-0">
      <v-row>
        <v-col cols="6" sm="3" class="py-0">
          <DateInput
            :date="start_date_from"
            @update="
              val => {
                start_date_from = val;
                startQueryForSearch();
              }
            "
            :label="$t('contract-periods.start-date-from')"
          ></DateInput>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <DateInput
            :date="start_date_to"
            @update="
              val => {
                start_date_to = val;
                startQueryForSearch();
              }
            "
            :label="$t('contract-periods.start-date-to')"
            clearable
          ></DateInput>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <DateInput
            :date="end_date_from"
            @update="
              val => {
                end_date_from = val;
                startQueryForSearch();
              }
            "
            :label="$t('contract-periods.end-date-from')"
            clearable
          ></DateInput>
        </v-col>
        <v-col cols="6" sm="3" class="py-0">
          <DateInput
            :date="end_date_to"
            @update="
              val => {
                end_date_to = val;
                startQueryForSearch();
              }
            "
            :label="$t('contract-periods.end-date-to')"
            clearable
          ></DateInput>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="py-0">
          <v-autocomplete
            :value="cost_centre"
            @input="
              val => {
                cost_centre = val;
                startQueryForSearch();
              }
            "
            :items="costCentres"
            :label="$t('contract-periods.cost-centre')"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" class="py-0">
          <AutocompleteContacts
            :item="contact"
            :clearable="true"
            label="contract-periods.contact"
            :updated="
              val => {
                contact = val;
                startQueryForSearch();
              }
            "
          ></AutocompleteContacts>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="1" class="reset">
      <v-btn block v-on:click="reset" :loading="loading">
        <v-icon>
          mdi-filter-remove-outline
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import DateInput from "../../../common/inputs/DateInput";
import AutocompleteContacts from "../../../common/inputs/AutocompleteContacts";
export default {
  name: "SearchContractPeriod",
  components: {
    DateInput,
    AutocompleteContacts
  },
  data: function() {
    let start_date_from = this.$route.query.start_date_from || undefined,
      start_date_to = this.$route.query.start_date_to || undefined,
      end_date_from = this.$route.query.end_date_from || undefined,
      end_date_to = this.$route.query.end_date_to || undefined,
      contact = this.$route.query.contact || undefined,
      cost_centre = this.$route.query.cost_centre || undefined;

    return {
      start_date_from,
      start_date_to,
      end_date_from,
      end_date_to,
      contact,
      cost_centre,
      loading: false
    };
  },
  computed: {
    costCentres() {
      return this.$store.getters[
        "projectAccountingStore/costCentreStore/getList"
      ].map(i => ({
        value: i.id,
        text: i.name
      }));
    }
  },
  methods: {
    startQueryForSearch() {
      let to = { ...this.$route };
      to.query = {
        ...to.query
      };
      let vm = this;
      function formParam(param) {
        if (vm[param]) {
          to.query[param] = vm[param];
        } else {
          delete to.query[param];
        }
      }
      formParam("start_date_from");
      formParam("start_date_to");
      formParam("end_date_from");
      formParam("end_date_to");
      formParam("contact");
      formParam("cost_centre");
      this.$router.push(to);
    },
    reset() {
      let to = { ...this.$route };
      this.search = "";
      to.query = {};
      this.$router.push(to);
      this.start_date_from = undefined;
      this.start_date_to = undefined;
      this.end_date_from = undefined;
      this.end_date_to = undefined;
      this.contact = undefined;
      this.cost_centre = undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
.menu::v-deep {
  .v-text-field__details {
    display: none;
  }
  .v-select {
    margin-top: 0;
  }
}
</style>
